import { createAction, props } from '@ngrx/store';
import { IFolder } from '../../models/article.model';
import { EntityActions } from '../entity.actions';

export const fromFolderActions = { ...EntityActions.create<IFolder>('[Folder]'), preselected: createAction(`[Folder] Preselected`, props<{ entity: IFolder }>()) };
